export default __webpack_public_path__ + "static/media/everyone-open-eyes.be8663eb.mp3";